<template>
  <div class="l-learn-question-answer">
    <!-- 在线测评 -->
    <LLearnABCOptionsTest
      v-if="
        ELEMENT_TYPES.ABC_OPTIONS_TEST === SOURCE_TO_ELEMENT[currentELementType]
      "
      v-on="$listeners"
    />
    <!-- ABC讲解测试 -->
    <LLearnABCExplainTest
      v-if="
        ELEMENT_TYPES.ABC_EXPLAIN_TEST === SOURCE_TO_ELEMENT[currentELementType]
      "
      v-on="$listeners"
    />
    <!-- 扩听故事 -->
    <LLearnWholeTalk
      v-if="
        ELEMENT_TYPES.EXPLAIN_TEST === SOURCE_TO_ELEMENT[currentELementType]
      "
      v-on="$listeners"
    />
    <!-- 语音测评 -->
    <LLearVoiceTest
      v-if="ELEMENT_TYPES.AUDIO_TEST === SOURCE_TO_ELEMENT[currentELementType]"
      @next="onNext"
    />
    <!-- 语音测评 -->
    <LLearAudioRead
      v-if="ELEMENT_TYPES.AUDIO_READ === SOURCE_TO_ELEMENT[currentELementType]"
      @next="onNext"
    />
    <!-- 跟读测评 -->
    <LLearnFoloowRead
      v-if="
        ELEMENT_TYPES.LISTEN_REPEAT_TEST ===
        SOURCE_TO_ELEMENT[currentELementType]
      "
      @next="onNext"
    />
    <!-- 自读测评 -->
    <LLearnSelfRead
      v-if="
        ELEMENT_TYPES.SELF_READING_TEST ===
        SOURCE_TO_ELEMENT[currentELementType]
      "
      @next="onNext"
    />
  </div>
</template>

<script>
import LLearnABCExplainTest from '../l-learn-abc-explain-test'
import LLearnABCOptionsTest from '../l-learn-abc-options-test' // 在线测评
import LLearnWholeTalk from '../l-learn-whole-talk'
import LLearnFoloowRead from '../l-learn-follow-read' //跟读
import LLearnSelfRead from '../l-learn-self-read' //自读
import LLearVoiceTest from '../l-learn-voice-test' // 语音测评
import LLearAudioRead from '../l-learn-audio-read' // 语音测评
import elementTypes from '../../minxin/elementTypes'

export default {
  components: {
    LLearnABCOptionsTest,
    LLearnABCExplainTest,
    LLearnWholeTalk,
    LLearnFoloowRead,
    LLearnSelfRead,
    LLearVoiceTest,
    LLearAudioRead,
  },
  mixins: [elementTypes],
  data() {
    return {
      currentELementType: '',
    }
  },
  created() {
    this.currentELementType = this.$route.params.elementType
  },
  methods: {
    onNext() {
      this.$emit('next')
    },
  },
}
</script>
<style lang="stylus" scoped>
@import './style/layout.styl'
</style>
